'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = exponential;

var _common = require('./common');

// [ref](https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average)
function exponential() {
  var _check = _common.check.apply(undefined, arguments);

  var _check2 = _slicedToArray(_check, 3);

  var datum = _check2[0];
  var size = _check2[1];
  var alpha = _check2[2];


  return datum.reduce(function (prev, current, index, array) {
    if (index === 0) {
      prev.prev = current;
    } else {
      prev.prev = alpha * current + (1 - alpha) * prev.prev;
    }

    if (index > size - 2) {
      prev.ma.push(prev.prev);
    }

    return prev;
  }, {
    prev: null,
    ma: []
  }).ma;
}